module.exports = __webpack_public_path__ + "img/emoji_52.192cb756.png";